import Reflux from 'reflux'

export default Reflux.createActions([
	'addRecipeToList',
	'setCategoryID',
	'setRecipeID',
	'qtyLess',
	'qtyMore',
	'delete',
	'getRecipeIngredients',
	'setPurchased'
])



// WEBPACK FOOTER //
// ./src/modules/shoppingList/listActions.js